import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=8f9d2860&"
import script from "./UserAvatar.vue?vue&type=script&lang=js&"
export * from "./UserAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f9d2860')) {
      api.createRecord('8f9d2860', component.options)
    } else {
      api.reload('8f9d2860', component.options)
    }
    module.hot.accept("./UserAvatar.vue?vue&type=template&id=8f9d2860&", function () {
      api.rerender('8f9d2860', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/core/Components/UserAvatar.vue"
export default component.exports